'use client';

import { useEffect } from 'react';
import { usePathname } from '@/core/i18n/routing';
import { setCartReturnPath } from '@/core/utils/cart-return-path';

/**
 * Remembers the last shopping page so the cart back button can return there.
 * Skips cart, checkout, and configurator so those funnels are not stored.
 */
const useRememberCartReturnPath = (): void => {
  const pathname = usePathname();

  useEffect(() => {
    setCartReturnPath(pathname);
  }, [pathname]);
};

export default useRememberCartReturnPath;
